import React from "react";
import "../styles/PermissionFeedback.css";

export default function PermissionNotice({
  action = "edit",
  resource = "this item",
  message,
  compact = false,
}) {
  const text =
    message ||
    `You have view-only access. You don't have permission to ${action} ${resource}.`;

  return (
    <div
      className={`permission-notice${compact ? " permission-notice--compact" : ""}`}
      role="status"
    >
      <i className="fas fa-lock" aria-hidden="true" />
      <span>{text}</span>
    </div>
  );
}
